import { LOADED, STATUS_NOT_LOADED } from "../../api/constant";

export const types = {
  CHANGE_INPUT_FILTER_BRANDS: "change_input_filter_brands",
  BRANDS_LOADED: "brands_loaded",
  SET_FIELD_FORM_BRAND: "set_field_form_brand",
  SET_EDIT_FORM_BRAND: "set_edit_form_brand",
  EDIT_FORM_BRAND: "edit_form_brand",
  RELOAD_INDEX_BRANDS: "reload_index_brands",
};

export const INITIAL_STATE = {
  elements: [],
  status: STATUS_NOT_LOADED,
  filter: {
    limit: 20,
    page: 1,
  },
  rows: 0,
  edit_brand: {
    id: null,
    name: "",
    description: "",
  },
  for_edit: false,
};

export const brandsReducer = (state, action) => {
  const payload = action.payload;
  const {
    CHANGE_INPUT_FILTER_BRANDS,
    BRANDS_LOADED,
    SET_FIELD_FORM_BRAND,
    SET_EDIT_FORM_BRAND,
    EDIT_FORM_BRAND,
    RELOAD_INDEX_BRANDS,
  } = types;

  switch (action.type) {
    case BRANDS_LOADED:
      return {
        ...state,
        elements: payload.elements,
        rows: payload.rows,
        status: LOADED,
      };

    case CHANGE_INPUT_FILTER_BRANDS:
      return {
        ...state,
        status: STATUS_NOT_LOADED,
        filter: {
          ...state.filter,
          [payload.name]: payload.value,
        },
      };

    case SET_FIELD_FORM_BRAND:
      return {
        ...state,
        edit_brand: {
          ...state.edit_brand,
          [payload.name]: payload.value,
        },
      };

    case SET_EDIT_FORM_BRAND:
      return {
        ...state,
        for_edit: payload,
      };

    case EDIT_FORM_BRAND:
      return {
        ...state,
        edit_brand: payload,
      };

    case RELOAD_INDEX_BRANDS:
      return {
        ...state,
        status: STATUS_NOT_LOADED,
      };

    default:
      return state;
  }
};
